import React from 'react';
import AddProductComponent from './AddProduct.component';
import { useNavigation } from '../../../Hooks';

export const useAddProductContainer = () => {
  const { goBack, getParams } = useNavigation();

  const { id, customerId } = getParams();

  const handleBack = () => {
    goBack();
  };

  return {
    handleBack,
    id,
    customerId,
  };
};

const AddProductContainer = () => {
  const { handleBack } = useAddProductContainer();
  return <AddProductComponent handleBack={handleBack} />;
};

export default AddProductContainer;
